/**
 * Refresh 11c: Final Polish — refresh-pipeline twin of Stage 7c.
 * Same behavior/guardrails; reuses the polish report renderer.
 */
import React from 'react';
import { StagePanel } from '../StagePanel';
import { renderPolishOutput } from './Stage7cFinalPolishV2';

export function RefreshFinalPolishV2() {
  return (
    <StagePanel
      stageId="refresh_11c_polish"
      title="Refresh 11c: Final Polish"
      description="Final editorial + SEO-fix pass before the refreshed article is published. Fixes flagged SEO issues and lightly improves the article. All internal links and CTA shortcodes are preserved by guardrails — if a polish would drop one or worsen SEO, it is rejected and the original is kept."
      isLlmStage
      renderOutput={renderPolishOutput}
    />
  );
}
